module.exports = __webpack_public_path__ + "img/main_home1.0606698.svg";